module.exports = __webpack_public_path__ + "images/address-success-ca12a5402de05af5d128a636db79e802.png";